<template>
<!-- 学历 -->
  <div class="txzl-wrap">
    <p>*您的信息仅展示给银行或持牌平台，未经您授权我们不会泄露您的信息*</p>
    <div class="txzl-wrap-title">
      <span>您的学历是？</span>
      <span @click="$router.go(-1)" v-if="loanNumber!== 1">上一步</span>
    </div>
    <div>
      <van-radio-group v-model="culture_name" @change="goNext">
        <van-cell-group :border="false"> 
          <van-cell v-for="(items, index) in cultureData" :key="index" :title="items.text" :border="false" checked-color="#0294FF" @click="checkVlue(items.text_value)" clickable>
            <template #right-icon>
              <van-radio :name="items.text_value" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="btn-fixed" @click="goNext">
      <div class="loanbtn">
        <p>下一步({{loanNumber}}/{{infoData.param_total}})</p>
      </div>
    </div>
  </div>
</template>
<script>
import { CellGroup, Cell, Radio, RadioGroup, Button, Toast } from 'vant'
export default {
  name: 'Xueli',
  data() {
    const culture_name = JSON.parse(window.localStorage.getItem('loanParams')).culture_name
    const infoData = JSON.parse(window.localStorage.getItem('infoData'))
    return {
      culture_name: !!culture_name ? culture_name : '',
      cultureData: infoData.result.culture_name.options,
      loanNumber: Number(this.$route.query.loanNumber),
      channel_lable: window.localStorage.getItem('channel'),
      loanBtnWidth: 0,
      infoData
    }
  },
  created() {
    this.loanBtnWidth = ((this.loanNumber-1)/Number(this.infoData.param_total))*100
  },
  methods: {
    checkVlue(value) {
      this.culture_name = value
    },
    goNext() {
      if(!!this.culture_name) {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        });
        let loanParams = JSON.parse(window.localStorage.getItem('loanParams'))
        loanParams['culture_name'] = this.culture_name
        window.localStorage.setItem('loanParams', JSON.stringify(loanParams))
        const loanNumber = this.loanNumber + 1
        this.$router.push('/loan/components/baseinfo?channel_lable='+ this.channel_lable+'&loanNumber='+ loanNumber)
      }else {
        this.$toast('请选择')
      }
    }
  },
  components: {
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button
  }
}
</script>